<script setup lang="ts">
import { MediaImageFragment } from '~/api/graphql/generated'
import { Link } from '~/types'

export interface HeroProps {
  logo?: MediaImageFragment
  back?: Link
  content: {
    title: string
    subtitle?: string
    intro?: string
  }
}
defineProps<HeroProps>()
</script>

<template>
  <Section v-animate="{ cluster: 'true' }" :class="['section-hero', 'section-hero-color']">
    <div class="background">
      <Image
        v-if="logo"
        v-animate="{ animation: 'vertical-reveal' }"
        :entity="logo"
        type="teaser-main-menu"
        class="logo"
      />
    </div>
    <div class="content">
      <ButtonBack v-if="back" v-animate="{ animation: 'vertical-reveal' }" :to="back.url">
        {{ back.text }}
      </ButtonBack>
      <h1 v-animate="{ animation: 'vertical-reveal' }" class="title">{{ content.title }}</h1>
      <p v-animate="{ animation: 'vertical-reveal' }" class="subtitle">{{ content.subtitle }}</p>
    </div>
  </Section>
</template>
<style scoped lang="scss">
.hero-color {
  grid-template-columns: 100%;
  margin-bottom: 0;

  --offset-left: 24px;
  @include breakpoint(t) {
    --offset-left: 40px;
  }
  @include breakpoint(d) {
    --offset-left: 80px;
  }

  .background,
  .content {
    grid-column: 1;
    grid-row: 1;
  }
}

.background {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-color: var(--c-red-100);
  @include fluid(min-height, 320px, 540px);
}

.logo {
  max-width: 140px;

  position: absolute;
  top: 24px;
  left: var(--offset-left);
  @include breakpoint(t) {
    top: 40px;
  }
}

.content {
  align-self: end;
  margin-left: var(--offset-left);

  @include fluid(padding-top, 160px, 210px);
  @include fluid(padding-bottom, 32px, 96px);

  @include breakpoint(tl) {
    max-width: 75%;
  }

  :deep(*) {
    color: var(--c-white) !important;
  }
}

.button.back {
  @include fluid(margin-bottom, 30px, 40px);
}
.title,
.subtitle {
  margin-bottom: 0;
}

.subtitle {
  font-weight: bold;
  color: var(--c-primary);
  @include f-24;
}
</style>
